import React from 'react';
import { formatDublinDate } from '../../utils/date';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { isAdminRole } from '../../types';
import {
  BuildingOfficeIcon,
  ArrowLeftIcon,
} from '@heroicons/react/24/outline';

const getRoleBadgeColor = (role: string) => {
  const roleStr = String(role);
  if (isAdminRole(roleStr)) return 'bg-purple-100 text-purple-800';
  if (roleStr === 'STAFF') return 'bg-blue-100 text-blue-800';
  if (roleStr === 'PARENT') return 'bg-green-100 text-green-800';
  return 'bg-gray-100 text-gray-800';
};

const Memberships: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="py-6" data-testid="settings-memberships">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-6">
          <Link to="/settings" className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700 mb-4">
            <ArrowLeftIcon className="h-4 w-4" />
            Back to Settings
          </Link>
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
            Memberships
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            Your organization and location memberships
          </p>
        </div>

        <div className="bg-white shadow rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <h3 className="text-lg leading-6 font-medium text-gray-900 flex items-center mb-4">
              <BuildingOfficeIcon className="h-5 w-5 mr-2" />
              Your Memberships
            </h3>
            <div className="space-y-4">
              {user?.memberships?.map((membership) => (
                  <div key={membership.locationId || membership.organizationId || membership.role} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div>
                      <p className="text-sm font-medium text-gray-900">
                        {membership.role === 'SUPER_ADMIN'
                          ? 'Platform Administrator'
                          : membership.locationName || membership.organizationName || 'Unknown'}
                      </p>
                      <p className="text-xs text-gray-500">
                        {membership.role === 'SUPER_ADMIN'
                          ? 'Full access to all organizations and locations'
                          : `Since ${formatDublinDate(membership.createdAt)}`}
                      </p>
                    </div>
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getRoleBadgeColor(membership.role)}`}>
                      {membership.role === 'SUPER_ADMIN' ? 'Super Admin'
                        : membership.role === 'ORG_ADMIN' ? 'Org Admin'
                        : membership.role === 'LOCATION_ADMIN' ? 'Location Admin'
                        : membership.role}
                    </span>
                  </div>
                ))}
              {(!user?.memberships || user.memberships.length === 0) && (
                <p className="text-sm text-gray-500">No memberships found.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Memberships;
